import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { ForgotPasswordComponent } from './modules/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  },
  {
    path: 'learner',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/learner-layout/learner-layout.module').then(m => m.LearnerLayoutModule),
  },
  {
    path: 'forget-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  // {
  //   path: 'shared/machine/view/:id',
  //   canActivate: [AuthGuard],
  //   component: MachineViewDetailsComponent,
  // },
  {
    path: 'common',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/common-layout/common-layout.module').then(m => m.CommonLayoutModule),
  },
  {
    path: 'my-ln-profile',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/learner-layout/learner-layout.module').then(m => m.LearnerLayoutModule),
  },
  {
    path: 'my-profile',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./shared/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
